const theme = {
  buttonWrapper: "draftJsToolbar__buttonWrapper",
  button: "draftJsToolbar__button",
  active: "draftJsToolbar__buttonActive",
  seperator: "draftJsToolbar__separator",
};

export default theme;
